<div class="flex flex-column w-full h-screen min-h-screen">
  <!-- Navigation -->
  <medsurf-navbar></medsurf-navbar>
  <!-- Toolbar -->
  <medsurf-design-content-toolbar [class]="'mb-2'">
    <!-- Content -->
    <div class="p-toolbar-group-start">
      &nbsp;
    </div>
    <div class="p-toolbar-group-end">
      @if ({
        canRedo: historySharedFacade.canRedo$ | async,
        canUndo: historySharedFacade.canUndo$ | async
      }; as historyData) {
        <div
          class="flex flex-row flex-wrap align-items-center gap-2">
          <button medsurf-design-input-button [id]="'undo'"
            [title]="'global.undo' | translate"
            [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY"
            [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.UNDO"
            [disabled]="historyData.canUndo === false"
          (click)="executeUndo()"></button>
          <button medsurf-design-input-button [id]="'redo'"
            [title]="'global.redo' | translate"
            [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY"
            [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.REDO"
            [disabled]="historyData.canRedo === false"
          (click)="executeRedo()"></button>
          @if ({
            canSave: historySharedFacade.canSave$ | async
          }; as saveData) {
            <button medsurf-design-input-button [id]="'save_changes'"
              [label]="'global.save_changes' | translate"
              [inputClass]="(saveData.canSave === false ? FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY : FlatModels.ButtonDesignModels.ButtonDesignClass.WARNING)"
              [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.SAVE"
              [disabled]="saveData.canSave === false"
            (click)="executeSave()"></button>
            @if (slideAuthorFacade.currentSelectedRouteElement$ | async; as routeElement) {
              <button medsurf-design-input-button
                [id]="'preview'"
                [label]="'global.preview' | translate"
                [inputClass]="(saveData.canSave === false ? FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY : FlatModels.ButtonDesignModels.ButtonDesignClass.WARNING)"
                [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.PREVIEW"
              (click)="openNodePreview(routeElement)"></button>
            }
          }
        </div>
      }
    </div>
  </medsurf-design-content-toolbar>
  <!-- Search Results -->
  <div class="w-full h-full overflow-hidden">
    <!-- Data View -->
    @let layout = (slideAuthorFacade.layout$ | async) ?? 'list';
    @if (searchControlFacade.detachedPageSearchResult$ | async; as detachedPageSearchResult) {
      <medsurf-design-content-sortable-data-view
        [value]="detachedPageSearchResult.items"
        [gridStyleClass]="'flex flex-wrap gap-2 p-2'"
        [listStyleClass]="'p-2'"
        [paginatorDropdownScrollHeight]="'300px'"
        [trackBy]="trackBy"
        [rows]="searchForm.value.rows || 10"
        [layout]="layout"
        (onChangeLayout)="changeLayout($event)"
        [pageLinks]="5"
        [totalRecords]="detachedPageSearchResult.total"
        [paginator]="true"
        [lazy]="true"
        [first]="searchForm.value.first || 0"
        [draggable]="false"
        (onLazyLoad)="onLazy($event)"
        (onPage)="onSubmit(false)">
        <!-- Header -->
        <ng-template pTemplate="header"
          class="overflow-auto h-full">
          <div class="flex column-gap-2 w-full p-2">
            <div class="flex-grow-1">
              @if (searchForm) {
                <medsurf-design-form-control-form
                  [formGroup]="searchForm"
                  [class]="'w-full'"
                  (onSubmit)="onSubmit()">
                  <div class="flex flex-wrap gap-2">
                    <!-- Search String -->
                    <medsurf-design-form-control-input-text #searchStringInputText
                      [formField]="false"
                      [control]="searchForm.controls.searchString"
                      [placeholder]="'global.search_query'"
                      [autofocus]="true"
                      [class]="'flex-grow-1'"
                    (valueChange)="onSubmit()"></medsurf-design-form-control-input-text>
                    <!-- Created By Me -->
                    <medsurf-design-form-control-input-switch [formField]="false"
                      [control]="searchForm.controls.createdByMe"
                      [label]="'global.created_by_me'"
                      [class]="'flex'"
                      [labelTop]="false"
                    (valueChange)="onSubmit()"></medsurf-design-form-control-input-switch>
                  </div>
                </medsurf-design-form-control-form>
              }
            </div>
            <div class="flex flex-shrink-0 gap-2">
              <!-- Bulk Actions -->
              <medsurf-design-input-menu [formField]="false"
                [name]="'slides_menu'"
                [label]="'global.slides'"
              [loadMenuItems]="getSlidesMenuItems"></medsurf-design-input-menu>
              <!-- Layout Options -->
              <medsurf-design-content-sortable-data-view-layout-options [layout]="layout"></medsurf-design-content-sortable-data-view-layout-options>
            </div>
          </div>
          <div class="p-2">
            @if (layout === 'list') {
              <div
                class="table-head h-5rem pl-2 pr-3 cursor-pointer overflow-hidden">
                <div class="w-2rem">
                  &nbsp;
                </div>
                @if (searchControlFacade.detachedPagesSet$ | async; as detachedPagesSet) {
                  <div
                    class="w-3rem flex-shrink-0">
                    @if ({
                      hasAllBulkEditPages: (nodeSharedFacade.hasAllBulkEditPages$(Array.from(detachedPagesSet)) | async) || false
                    }; as bulkData) {
                      <medsurf-design-input-checkbox [formField]="false"
                        [name]="'page_select_all'"
                        [model]="bulkData.hasAllBulkEditPages"
                        [class]="'table-header-switch'"
                      (valueChange)="onToggleBulkPages(detachedPagesSet, !bulkData.hasAllBulkEditPages)"></medsurf-design-input-checkbox>
                    }
                  </div>
                }
                <div class="w-5rem flex-shrink-0">
                  &nbsp;
                </div>
                <span translate="global.slide_id"
                class="w-5rem"></span>
                <span translate="global.title"
                class="w-20rem flex-grow-1"></span>
                <span translate="global.resource_type"
                class="w-8rem"></span>
                <span translate="global.modality"
                class="w-13rem"></span>
                <span translate="global.status"
                class="w-5rem"></span>
              </div>
            }
          </div>
        </ng-template>
        <!-- Content -->
        <!-- List Item -->
        <ng-template pTemplate="listItem"
          let-slide
          let-rowIndex="rowIndex">
          @if ({
            hasBulkEditPage: (nodeSharedFacade.hasBulkEditPage$(slide.id) | async) || false
          }; as pageData) {
            <div class="table-row h-5rem pl-2 cursor-pointer overflow-hidden hover:bg-primary-200 node"
              [ngClass]="{'bg-primary-300': pageData.hasBulkEditPage}"
              (click)="onPageClick($event, slide.id)">
              <div class="w-2rem">
                {{ this.searchForm.value.first + rowIndex + 1 }}
              </div>
              <div class="w-3rem flex-shrink-0">
                <medsurf-design-input-checkbox [formField]="false"
                  [name]="'page_list_select_' + slide.id"
                  [model]="pageData.hasBulkEditPage"
                (valueChange)="onToggleBulkPage(slide.id)"></medsurf-design-input-checkbox>
              </div>
              <div class="w-5rem flex-shrink-0">
                <img class="block h-4rem w-4rem bg-black-alpha-30"
                  [src]="mediaControlService.getUrl(slide.media, 'thumbnail') || '/assets/images/no-image.png'"
                  [alt]="slide.media?.name || 'global.error_loading_image' | translate" />
              </div>
              <span class="w-5rem">
                {{ slide.slideId || '-' }}
              </span>
              <span class="w-20rem flex-grow-1 text-overflow-ellipsis-2">
                {{ slide.title }}
              </span>
              <span class="w-8rem">
                {{ mediaControlService.getMediaTypeIconByType(slide.mediaType) | translate }}
              </span>
              <span class="w-13rem">
                {{ slide.modality?.name || '-' }}
              </span>
              <span class="w-5rem">
                {{ slide.status || '-' | translate }}
              </span>
            </div>
          }
        </ng-template>
        <!-- Grid Item -->
        <ng-template pTemplate="gridItem"
          let-slide
          let-rowIndex="rowIndex">
          @if ({
            hasBulkEditPage: (nodeSharedFacade.hasBulkEditPage$(slide.id) | async) || false
          }; as pageData) {
            <div class="flex flex-column w-12rem h-16rem border-1 border-round cursor-pointer overflow-hidden hover:border-primary-200 hover:bg-primary-200 drag-node"
              [ngClass]="{'bg-primary-300': pageData.hasBulkEditPage}"
              [title]="slide.title"
              (click)="onPageClick($event, slide.id)">
              <div class="relative flex w-12rem h-12rem">
                @if (slide.slideId) {
                  <medsurf-design-content-chip
                    [tooltipLabel]="'global.slide_id' | translate"
                    [class]="'absolute top-0 left-0 m-2'">
                    {{ slide.slideId }}
                  </medsurf-design-content-chip>
                }
                <medsurf-design-input-checkbox [formField]="false"
                  [name]="'page_grid_select_' + slide.id"
                  [model]="pageData.hasBulkEditPage"
                  [class]="'h-3rem absolute top-0 right-0'"
                (valueChange)="onToggleBulkPage(slide.id)"></medsurf-design-input-checkbox>
                <div class="absolute flex gap-1 justify-content-start bottom-0 left-0 m-2">
                  <medsurf-design-content-chip [tooltipLabel]="'global.position' | translate">
                    #{{ this.searchForm.value.first + rowIndex + 1 }}
                  </medsurf-design-content-chip>
                  @if (slide.status && slide.status !== FlatModels.PageEntityModels.SlideStatus.enum.empty) {
                    <medsurf-design-content-chip
                      [tooltipLabel]="'global.status' | translate"
                      [styleClass]="'p-menu_icon'">
                      <i [class]="nodeSharedFacade.getSlideStatusIcon(slide)"></i>
                    </medsurf-design-content-chip>
                  }
                  <medsurf-design-content-chip [tooltipLabel]="'global.file_type' | translate"
                    [styleClass]="'p-menu_icon'">
                    <i [class]="mediaControlService.getMediaTypeIconByType(slide.mediaType)"></i>
                  </medsurf-design-content-chip>
                  @if (slide.type === FlatModels.PageEntityModels.PageType.enum.Training) {
                    <medsurf-design-content-chip
                      [tooltipLabel]="'enum.pageType.Training' | translate"
                      [styleClass]="'p-menu_icon'">
                      <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.PAGE_TRAINING"></i>
                    </medsurf-design-content-chip>
                  }
                </div>
                <img class="w-full bg-black-alpha-30"
                  [src]="mediaControlService.getUrl(slide.media, 'thumbnail') || '/assets/images/no-image.png'"
                  [alt]="slide.media?.name || 'global.error_loading_image' | translate" />
              </div>
              <div class="flex w-12rem align-items-start h-4rem p-2">
                <span class="overflow-hidden text-overflow-ellipsis-2">
                  {{ slide.title }}
                </span>
              </div>
            </div>
          }
        </ng-template>
      </medsurf-design-content-sortable-data-view>
    }
  </div>
</div>